import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PracticeTypingTest, { PracticeMode } from '../components/PracticeTypingTest';
import { Shell } from '../components/Shell';
import { Segmented } from '../components/Segmented';

type Duration = 10 | 30 | 60 | 120 | 300;

const durationOptions: { value: Duration; label: string }[] = [
  { value: 10,  label: '10s' },
  { value: 30,  label: '30s' },
  { value: 60,  label: '1 min' },
  { value: 120, label: '2 min' },
  { value: 300, label: '5 min' },
];

const modeOptions: { value: PracticeMode; label: string }[] = [
  { value: 'passages', label: 'Passages' },
  { value: 'words', label: 'Random Words' },
];

const Practice: React.FC = () => {
  const navigate = useNavigate();
  const [duration, setDuration] = useState<Duration>(60);
  const [mode, setMode] = useState<PracticeMode>('passages');
  const [testKey, setTestKey] = useState(0);

  const handleDurationChange = (d: Duration) => {
    setDuration(d);
    setTestKey(k => k + 1); // remount component to reset with new duration
  };

  const handleModeChange = (m: PracticeMode) => {
    setMode(m);
    setTestKey(k => k + 1);
  };

  return (
    <Shell>
      <div className="page-narrow">
        <div className="page-header">
          <h1>Practice</h1>
        </div>

        <div className="practice-controls">
          <Segmented ariaLabel="Practice text" options={modeOptions} value={mode} onChange={handleModeChange} keepFocus />
          <Segmented ariaLabel="Duration" options={durationOptions} value={duration} onChange={handleDurationChange} keepFocus />
        </div>

        {/* Typing Test */}
        <PracticeTypingTest key={testKey} duration={duration} mode={mode} />

        <div className="page-actions">
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/')}>
            Exit Practice
          </button>
        </div>
      </div>
    </Shell>
  );
};

export default Practice;
